/**
 * Transcript Provider Constants
 * 
 * Configuration for available transcript generation providers
 */

export const TRANSCRIPT_PROVIDERS = [
  {
    value: 'whisper-1',
    label: 'Whisper-1 (OpenAI) (deprecated)',
    description: 'OpenAI Whisper API - Cloud-based, fast and accurate'
  },
  {
    value: 'whisper-localhost',
    label: 'Whisper Localhost',
    description: 'Local Whisper server - Privacy-focused, self-hosted'
  },
  {
    value: 'sonix',
    label: 'Sonix',
    description: 'Sonix transcription service - Professional transcription'
  }
];

export const DEFAULT_PROVIDER = 'whisper-localhost';

